module.exports = __webpack_public_path__ + "img/indent-decrease-1.757e4228.svg";